import React from 'react';
import './App.css';
import { Route, Routes , BrowserRouter} from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Attendance from './components/Attendance';
import Home2 from './pages/Home/Home2';
import Administration from './components/Administration';
import Otp from './pages/Otp/Otp';
import Payroll from './components/Payroll';
import Employee from './components/Employee';
// import Dashboard from './components/Dashboard';
import Document from './components/Document';
import LeaveManagement from './components/LeaveManagement';
import Logout from './components/Logout';
import Setting from './components/Setting';
import Recruitment from './components/Recruitment';
import EmployeeFolder from './components/EmployeeFolder/EmployeeFolder'
import Login from './pages/Login/Login';
import CreateAccount from './pages/Home/CreateAccount';
import GoXDashboard from './pages/GoXDashboard/GoXDashboard';
import ForgottenPassword from './pages/Login/ForgetPassword';
import ForgottenPasswordLink from './pages/Login/ForgotPasswordLink';
import ResetPassword from './pages/Login/ResetPassword'




const Home = React.lazy(() => import("./pages/Home/Home"))
// const Home2 = React.lazy(() => import("./pages/Home/Home2"))
// const Otp = React.lazy(() => import("./pages/Otp/Otp"))
// const GoXDashboard = React.lazy(() => import("./pages/GoXDashboard/GoXDashboard"))
const Onboarding = React.lazy(() => import("./pages/Onboarding/Onboarding"))

// const Otp = React.lazy(() => import("./pages/Otp/Otp"))

function App() {
  return (
    <div>
      < BrowserRouter>
          <Routes>
            <Route exact path="/create-account" element={<CreateAccount/>} />
            <Route path="/Home2"element={<Home2/>} />
            <Route path='/Otp' element={<Otp />} />
            <Route path='/Onboarding' element={<Onboarding/>} />

            <Route path='/' element={<GoXDashboard />}/>
            <Route path='/forgotten-password-link' element={<ForgottenPasswordLink />}/>
            <Route path='/forgotten-password' element={<ForgottenPassword />}/>
            {/* <Route path="GoXDashboard/Dashboard" element={<Dashboard />} /> */}
          
            <Route path="/Dashboard" element={<GoXDashboard><Dashboard /></GoXDashboard>} />
            <Route path="/Employee" element={<GoXDashboard> <Employee></Employee> </GoXDashboard>} />
            <Route path="/Document" element={ <GoXDashboard><Document /></GoXDashboard>} />
            <Route path="/LeaveManagement" element={<GoXDashboard><LeaveManagement /></GoXDashboard>} />
            <Route path="/Logout" element={<GoXDashboard><Logout /></GoXDashboard>} />
            <Route path="/Login" element={<Login />} />
            <Route path="/ResetPassword" element={<ResetPassword/>} />
            
            <Route path="/Payroll" element={<GoXDashboard><Payroll /></GoXDashboard>} />
            <Route path="/Recruitment"element={<GoXDashboard><Recruitment /></GoXDashboard>} />
            <Route path="/Setting" element={<GoXDashboard><Setting /></GoXDashboard>} />
            <Route path="/Attendance" element={<GoXDashboard><Attendance/></GoXDashboard>} />
            <Route path="/Administration" element={<GoXDashboard>< Administration/></GoXDashboard>} />
           


            </Routes>
     </ BrowserRouter>
    </div>
  );
}

export default App;
